import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SectionIntro from './SectionIntro';
import { benefits, services } from '../data/content';

const { FiArrowUpRight, FiCheck } = FiIcons;

function Story() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="section story" id="why-us">
      <div className="container split-layout">
        <motion.div
          className="story-image-wrap"
          initial={reduceMotion ? false : { opacity: 0, x: -35 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-100px' }}
        >
          {/* Replace with a real crew or owner photo before launch. */}
          <img
            src="https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&w=1200&q=85"
            alt="Professional contractor reviewing a residential project"
            loading="lazy"
          />
          <div className="experience-badge"><strong>Since</strong><span>2008</span></div>
        </motion.div>

        <div>
          <SectionIntro
            eyebrow="Our Story"
            title="From Chicago Roots to Austin's Most Trusted Painters"
          />
          <motion.div
            className="story-copy"
            initial={reduceMotion ? false : { opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p>
              Windy City Painters Inc was founded in 2008 with one simple standard:
              show up when we say we will, and finish the job the way we'd want it
              done in our own home.
            </p>
            <p>
              Led by Cesar and a crew that treats every project like it's the only
              one on the schedule, we bring big-city craftsmanship to every interior,
              exterior, commercial, and specialty finishing job we touch.
            </p>
            <div className="callout">
              <SafeIcon icon={FiCheck} />
              <span>Family-run. Locally operated. NAPCO-certified in cabinet and bathtub resurfacing.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

function Services() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="section services" id="services">
      <div className="container">
        <SectionIntro
          eyebrow="What We Do"
          title="One Crew. Every Finish. Zero Headaches."
          description="From a single accent wall to a full commercial repaint, we handle it with the same attention to detail."
          centered
        />
        <div className="service-grid">
          {services.map((service, index) => (
            <motion.article
              className="service-card"
              key={service.title}
              initial={reduceMotion ? false : { opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-70px' }}
              transition={{ delay: index * 0.04, duration: 0.55 }}
              whileHover={reduceMotion ? {} : { y: -8 }}
            >
              <div className="service-icon"><SafeIcon icon={service.icon} /></div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <a href="#contact">Learn More <SafeIcon icon={FiArrowUpRight} /></a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

function Benefits() {
  return (
    <section className="section benefits">
      <div className="container">
        <SectionIntro
          eyebrow="Why Homeowners Choose Us"
          title="The Painting Company That Actually Shows Up"
          light
          centered
        />
        <div className="benefit-grid">
          {benefits.map((benefit) => (
            <motion.article
              key={benefit.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
            >
              <SafeIcon icon={benefit.icon} />
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export { Story, Services, Benefits };